import React from 'react';
import { useGetAllCreatives } from '@apis/creatives';
import {
  SelectCreatives,
  SelectCreativesFormValues,
} from '@components/modals/BulkEditModal/components/SelectCreatives/SelectCreatives';
import {
  ManageCreatives,
  ManageCreativesFormValues,
} from '@components/modals/BulkEditModal/components/ManageCreatives/ManageCreatives';
import { EditCreativesProps } from '@components/modals/BulkEditModal/constants/types';
import { Creative } from '@local-types';

export const EditCreatives = (props: EditCreativesProps) => {
  const { onSubmit } = props;

  // Currently only supporting video creatives
  const { items: library, isLoading } = useGetAllCreatives();

  const [selectedCreatives, setSelectedCreatives] = React.useState<
    Creative[]
  >([]);

  if (selectedCreatives && selectedCreatives.length > 0) {
    return (
      <ManageCreatives
        library={selectedCreatives}
        {...props}
        onSubmit={(values: ManageCreativesFormValues) => {
          onSubmit({ creatives: values.draftCreatives });
        }}
        onBack={() => {
          setSelectedCreatives([]);
        }}
      />
    );
  }

  return (
    <SelectCreatives
      library={library}
      isLoading={isLoading}
      initialCreatives={selectedCreatives}
      {...props}
      onSubmit={(values: SelectCreativesFormValues) => {
        setSelectedCreatives(values.creatives);
      }}
    />
  );
};
